"use client"
/* */
import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import * as Aria from 'react-aria-components';
import clsx from 'clsx';
import styles from '../../Popover.module.scss.mjs';

const PopoverContent = (props) => {
  const {
    children,
    className,
    isDialogContent = false,
    withTip,
    onOpenChange,
    ref,
    isOpen,
    width,
    padding = "m",
    ...rest
  } = props;
  const ContentComponent = isDialogContent ? Aria.Dialog : "div";
  return /* @__PURE__ */ jsxs(
    Aria.Popover,
    {
      ...rest,
      className,
      containerPadding: 16,
      ref,
      isOpen,
      onOpenChange,
      style: { width },
      children: [
        withTip && /* @__PURE__ */ jsx(Aria.OverlayArrow, { className: styles.tip, children: /* @__PURE__ */ jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", children: /* @__PURE__ */ jsx("path", { d: "M0 0 L8 8 L16 0" }) }) }),
        /* @__PURE__ */ jsx(
          ContentComponent,
          {
            className: clsx(
              styles.content,
              padding && styles[`padding-${padding}`]
            ),
            children
          }
        )
      ]
    }
  );
};

export { PopoverContent, PopoverContent as default };
//# sourceMappingURL=PopoverContent.mjs.map
